<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">                            
                            <el-option label="用户手机" :value="2"></el-option>
							<el-option label="观演人证件姓名" :value="3"></el-option>
							<el-option label="观演人证件号码" :value="4"></el-option>
							<el-option label="票品名称" :value="5"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.sessionId" placeholder="请选择" size="small">
				        <el-option label="不限制场次" value=""></el-option>
				        <el-option v-for="(item, index) in sessionIdNameList" :key="index" :label="item.name" :value="item.id"></el-option>
				    </el-select>
				</el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.channelName" placeholder="请选择" size="small">
                        <el-option label="不限制渠道" value=""></el-option>
                        <el-option v-for="(item, index) in qudaoNameList" :key="index" :label="item" :value="item"></el-option>
                    </el-select>
                </el-col>               
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
		<div class="page-list-box"  v-if="data">
		    <el-table
		        :data="data.result"
		        border
		        style="width: 100%"
		        v-loading="listLoading"
		        size="small"
		        stripe
		    >
		        <el-table-column label="状态" width="50">
		            <template slot-scope="scope">
		                {{scope.row.status == 1  ? '正常' : '已作废'}}
		            </template>
		        </el-table-column>		        
		        <el-table-column label="场次" prop="sessionName"></el-table-column>
		        <el-table-column label="渠道" prop="channelName"></el-table-column>
				<el-table-column label="票品名称" prop="ticketName"></el-table-column>				
		        <el-table-column label="票code" prop="ticketCode"></el-table-column>		        
		        <el-table-column label="用户手机" prop="tel" min-width="90"></el-table-column>
				<el-table-column label="观演人证件姓名" prop="documentName" min-width="90"></el-table-column>
				<el-table-column label="观演人证件类型" prop="documentType" min-width="90"></el-table-column>
				<el-table-column label="观演人证件号码" prop="documentNumber" min-width="90"></el-table-column>
				<el-table-column label="票品单价" prop="ticketPrice" min-width="90"></el-table-column>
				<el-table-column label="导入时间" prop="importTime" min-width="120"></el-table-column>        
		        <el-table-column fixed="right" label="操作"  >
		            <template slot-scope="scope">
		                <el-button
		                    type="text"
		                    size="small"
		                    v-if="$utils.have('/activity/realName/import_del') && scope.row.status == 1"
		                    icon="el-icon-delete"
		                    @click="cancellation(scope.row.ticketId)"
		                    >作废</el-button>
		            </template>
		        </el-table-column>
		    </el-table>
		</div>
		<div v-if="data" class="page-pagination-box">
		    <el-pagination
		        background
		        @size-change="handleSizeChange"
		        @current-change="getDataList"
		        :current-page.sync="params.pageNo"
		        :page-sizes="$pageSizes"
		        :page-size.sync="params.pageSize"
		        layout="total, sizes, prev, pager, next"
		        :total="data.totalCount || 0"
		    >
		    </el-pagination>
		</div>
    </div>
</template>

<script>
const defaultParams = {
    pageNo:1,
    searchType: 2,
    searchValue: '',
    channelName: '',
    detailType:2,
	sessionId:'',
}
export default {
    props: {
        id: {
            type: [Number, String],
            default: null,
        },
    },
    components: { },
    data() {
        return {
            redirect: this.$route.query.redirect || '/activityManage/activity/list',
            dataLoading: false,
            data: null,
            dataList: null,
            activityName: '',
            sessionIdNameList: [],
			qudaoNameList:[],
			params:{
			    ...defaultParams,
			    pageNo:parseInt(this.$route.query.pageNo || 1),
			    pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
			    searchType: parseInt(this.$route.query.searchType || 2),
			    searchValue: this.$route.query.searchValue || '',
			    channelName: this.$route.query.channelName || '',
				sessionId: this.$route.query.sessionId || '',
				
			},
			listLoading:false
        }
    },
    mounted() {
       this.getSession();
	   this.getQudao();
	   this.getDataList()
    },
    methods: {
        //返回
        goBack() {
            if (this.redirect) {
                this.$router.push({
                    path: this.redirect,
                });
            } else {
                this.$router.go(-1);
            }
        },
		//场次
		getSession() {
		    this.$request({
		        url: '/activity/sessionNames',
		        params: { activityId: parseInt(this.id) },
		        method: "post",
		    })
		        .then((res) => {
		            const { state, result } = res.data;
		            if (state == 1) {
		                this.sessionIdNameList = result || [];
		            }
		        })
		},
		//渠道
		getQudao() {
		    this.$request({
		        url: '/activity/realName/import_channel',
		        params: { activityId: parseInt(this.id),detailType:2 },
		        method: "post",
		    })
		        .then((res) => {
		            const { state, result } = res.data;
		            if (state == 1) {
		                this.qudaoNameList = result || [];
		            }
		        })
		},
        //获取数据
        getDataList() {
            this.dataLoading = true;
            this.$request({
                url: "/activity/realName/import_detail",               
				data: {...this.params ,activityId: parseInt(this.id)},
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                       this.data = result;
                       this.dataList = result.result || [];
                        
                    } else {
                        this.$message.error(msg || "获取数据失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取数据失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
       //作废事件
       cancellation(id){
		   var ticketId = id
           this.$confirm('确认是否要作废当前门票?作废后用户票夹中将不展示该门票', '门票作废', {
               type: 'warning',
               center: true,
               closeOnClickModal: false
           }).then(() => {
               this.listLoading = true;
               this.$request({
                   url: '/activity/realName/import_del',
                   method: 'POST',
                   params: {
					   activityId:parseInt(this.id),
					   detailType:2,
					   ticketId:ticketId
				   },
               }).then(res => {
                   const { state, msg } = res.data;
                   if( state == 1 ){
                       this.getDataList();
                   }else{
                       this.$message.error(msg || '请求失败');
                   }
               }).catch(() => {
                   this.$message.error('请求错误');
               }).finally(() => {
                   this.listLoading = false;
               });
           })
       },
	   //选择pageSize
	   handleSizeChange(e) {
	       this.params.pageNo = 1;
	       this.params.pageSize = e;
	       this.getDataList();
	   },
		//搜索
		search() {
		    this.params.pageNo = 1;
		    this.getDataList();
		},
		//重置搜索
		reset() {		    
		    this.params = {
		        ...defaultParams,
		        pageSize: this.params.pageSize,
		    };
		    this.getDataList();
		},
    }

}
</script>

<style lang="scss" scoped>

</style>